// Country list with flag emoji and dial codes
export const countries = [
  { code: "IN", name: "India", flag: "🇮🇳", dial: "+91" },
  { code: "AE", name: "United Arab Emirates", flag: "🇦🇪", dial: "+971" },
  { code: "US", name: "United States", flag: "🇺🇸", dial: "+1" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", dial: "+44" },
  { code: "SG", name: "Singapore", flag: "🇸🇬", dial: "+65" },
  { code: "MY", name: "Malaysia", flag: "🇲🇾", dial: "+60" },
  { code: "CA", name: "Canada", flag: "🇨🇦", dial: "+1" },
  { code: "AU", name: "Australia", flag: "🇦🇺", dial: "+61" },
  { code: "NZ", name: "New Zealand", flag: "🇳🇿", dial: "+64" },
  { code: "QA", name: "Qatar", flag: "🇶🇦", dial: "+974" },
  { code: "SA", name: "Saudi Arabia", flag: "🇸🇦", dial: "+966" },
  { code: "KW", name: "Kuwait", flag: "🇰🇼", dial: "+965" },
  { code: "BH", name: "Bahrain", flag: "🇧🇭", dial: "+973" },
  { code: "OM", name: "Oman", flag: "🇴🇲", dial: "+968" },
  { code: "NP", name: "Nepal", flag: "🇳🇵", dial: "+977" },
  { code: "LK", name: "Sri Lanka", flag: "🇱🇰", dial: "+94" },
  { code: "BD", name: "Bangladesh", flag: "🇧🇩", dial: "+880" },
  { code: "PK", name: "Pakistan", flag: "🇵🇰", dial: "+92" },
  { code: "BT", name: "Bhutan", flag: "🇧🇹", dial: "+975" },
  { code: "MV", name: "Maldives", flag: "🇲🇻", dial: "+960" },
  { code: "DE", name: "Germany", flag: "🇩🇪", dial: "+49" },
  { code: "FR", name: "France", flag: "🇫🇷", dial: "+33" },
  { code: "IT", name: "Italy", flag: "🇮🇹", dial: "+39" },
  { code: "ES", name: "Spain", flag: "🇪🇸", dial: "+34" },
  { code: "NL", name: "Netherlands", flag: "🇳🇱", dial: "+31" },
  { code: "CH", name: "Switzerland", flag: "🇨🇭", dial: "+41" },
  { code: "SE", name: "Sweden", flag: "🇸🇪", dial: "+46" },
  { code: "NO", name: "Norway", flag: "🇳🇴", dial: "+47" },
  { code: "DK", name: "Denmark", flag: "🇩🇰", dial: "+45" },
  { code: "FI", name: "Finland", flag: "🇫🇮", dial: "+358" },
  { code: "IE", name: "Ireland", flag: "🇮🇪", dial: "+353" },
  { code: "BE", name: "Belgium", flag: "🇧🇪", dial: "+32" },
  { code: "AT", name: "Austria", flag: "🇦🇹", dial: "+43" },
  { code: "PT", name: "Portugal", flag: "🇵🇹", dial: "+351" },
  { code: "GR", name: "Greece", flag: "🇬🇷", dial: "+30" },
  { code: "PL", name: "Poland", flag: "🇵🇱", dial: "+48" },
  { code: "RU", name: "Russia", flag: "🇷🇺", dial: "+7" },
  { code: "TR", name: "Turkey", flag: "🇹🇷", dial: "+90" },
  { code: "CN", name: "China", flag: "🇨🇳", dial: "+86" },
  { code: "JP", name: "Japan", flag: "🇯🇵", dial: "+81" },
  { code: "KR", name: "South Korea", flag: "🇰🇷", dial: "+82" },
  { code: "TH", name: "Thailand", flag: "🇹🇭", dial: "+66" },
  { code: "VN", name: "Vietnam", flag: "🇻🇳", dial: "+84" },
  { code: "ID", name: "Indonesia", flag: "🇮🇩", dial: "+62" },
  { code: "PH", name: "Philippines", flag: "🇵🇭", dial: "+63" },
  { code: "HK", name: "Hong Kong", flag: "🇭🇰", dial: "+852" },
  { code: "TW", name: "Taiwan", flag: "🇹🇼", dial: "+886" },
  { code: "ZA", name: "South Africa", flag: "🇿🇦", dial: "+27" },
  { code: "KE", name: "Kenya", flag: "🇰🇪", dial: "+254" },
  { code: "NG", name: "Nigeria", flag: "🇳🇬", dial: "+234" },
  { code: "EG", name: "Egypt", flag: "🇪🇬", dial: "+20" },
  { code: "MX", name: "Mexico", flag: "🇲🇽", dial: "+52" },
  { code: "BR", name: "Brazil", flag: "🇧🇷", dial: "+55" },
  { code: "AR", name: "Argentina", flag: "🇦🇷", dial: "+54" },
  { code: "CL", name: "Chile", flag: "🇨🇱", dial: "+56" },
  { code: "CO", name: "Colombia", flag: "🇨🇴", dial: "+57" },
  { code: "IL", name: "Israel", flag: "🇮🇱", dial: "+972" },
  { code: "MM", name: "Myanmar", flag: "🇲🇲", dial: "+95" },
  { code: "KH", name: "Cambodia", flag: "🇰🇭", dial: "+855" },
  { code: "LA", name: "Laos", flag: "🇱🇦", dial: "+856" },
  { code: "MN", name: "Mongolia", flag: "🇲🇳", dial: "+976" },
  { code: "UA", name: "Ukraine", flag: "🇺🇦", dial: "+380" },
  { code: "CZ", name: "Czech Republic", flag: "🇨🇿", dial: "+420" },
  { code: "HU", name: "Hungary", flag: "🇭🇺", dial: "+36" },
  { code: "RO", name: "Romania", flag: "🇷🇴", dial: "+40" },
  { code: "IS", name: "Iceland", flag: "🇮🇸", dial: "+354" },
  { code: "LU", name: "Luxembourg", flag: "🇱🇺", dial: "+352" },
  { code: "MT", name: "Malta", flag: "🇲🇹", dial: "+356" },
  { code: "CY", name: "Cyprus", flag: "🇨🇾", dial: "+357" },
  { code: "MU", name: "Mauritius", flag: "🇲🇺", dial: "+230" },
  { code: "FJ", name: "Fiji", flag: "🇫🇯", dial: "+679" },
];
